/**
 * Truncate text to a specified number of words
 */
export function truncateWords(text, maxWords) {
  if (!text) return '';

  const words = text.split(/\s+/);

  if (words.length <= maxWords) {
    return text;
  }

  return words.slice(0, maxWords).join(' ') + '...';
}

/**
 * Escape special regex characters for safe regex use
 */
export function escapeRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Highlight search matches in text using regex
 * Returns array of React-renderable elements
 */
export function highlightText(text, query) {
  if (!text || !query) return [text];

  const escapedQuery = escapeRegex(query);
  const regex = new RegExp(`(${escapedQuery})`, 'gi');

  return text.split(regex).map((part, index) => ({
    text: part,
    isMatch: regex.test(part)
  }));
}
